import { Vocab } from '../index';
export default function (selector) {
    return {
        selectRoot(resources, response) {
            const maybeView = selector.selectRoot(resources, response);
            if (maybeView && maybeView.types.contains(Vocab('PartialCollectionView'))) {
                return maybeView.collection;
            }
            return maybeView;
        },
    };
}
//# sourceMappingURL=PartialCollectionViewSelector.js.map